const Guide = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto space-y-8">
      <div>
        <h2 className="text-xl font-bold text-foreground mb-1">Guide</h2>
        <p className="text-sm text-muted-foreground">
          How to use the internal dashboard and our outreach playbook.
        </p>
      </div>

      {/* Dashboard Guide */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">How to use the dashboard</h3>

        <div className="space-y-3">
          <div className="bg-card border border-border rounded-xl p-4">
            <h4 className="font-medium text-sm text-foreground mb-1">1. Pipeline</h4>
            <p className="text-sm text-muted-foreground">
              The Kanban board shows all prospects across stages: Prospect, Contacted, In Conversation, Follow Up, Won, and Lost. Drag cards between columns to update status. Use the team filter at the top to see only your assigned leads.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <h4 className="font-medium text-sm text-foreground mb-1">2. Adding prospects</h4>
            <p className="text-sm text-muted-foreground">
              Click "Add Prospect" in the top bar or sidebar. Search for a venue by name - the system will try to auto-fill address, phone, website, and contact details using AI enrichment. Review the data before adding to the pipeline.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <h4 className="font-medium text-sm text-foreground mb-1">3. Prospect details</h4>
            <p className="text-sm text-muted-foreground">
              Click any card to open the detail panel. From there you can update contact info, add notes, log activities, assign team members, draft emails using templates, and see the follow-up recommendation if the lead is overdue.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <h4 className="font-medium text-sm text-foreground mb-1">4. Email templates</h4>
            <p className="text-sm text-muted-foreground">
              Go to Email Templates in the sidebar to manage your template bank. You can paste in emails you have already written (with bold, links, and formatting preserved) and categorise them by purpose or location type for quick reuse.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <h4 className="font-medium text-sm text-foreground mb-1">5. Follow-up reminders</h4>
            <p className="text-sm text-muted-foreground">
              If a prospect has not been contacted for 3+ days, an amber alert appears on their card with a recommended contact method (email, Instagram, or phone). Click the alert to see the contact details ready to go.
            </p>
          </div>
        </div>
      </section>

      {/* Outreach Playbook */}
      <section className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">How we do outreach</h3>

        <div className="space-y-3">
          <div className="bg-card border border-border rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">1</span>
              <h4 className="font-medium text-sm text-foreground">Website search and forms</h4>
            </div>
            <p className="text-sm text-muted-foreground">
              Go to the venue's website and search for anything that refers to self-service kiosks, leasing opportunities, pop-up events, or commercial partnerships. If they have a form for enquiries, reach out that way. If not, look for a general contact email address or any specific contact listed on their site.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">2</span>
              <h4 className="font-medium text-sm text-foreground">Direct email outreach</h4>
            </div>
            <p className="text-sm text-muted-foreground">
              If you find an email address from the website (whether from a form, a contact page, or a specific team member), use one of our email templates to send a personalised outreach. Make sure to reference the specific location and tailor the message.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-bold flex items-center justify-center">3</span>
              <h4 className="font-medium text-sm text-foreground">Instagram DM (warm outreach)</h4>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              This works really well. Find the venue's Instagram page and DM them personally with something like:
            </p>
            <div className="mt-2 bg-muted/50 border border-border rounded-lg p-3">
              <p className="text-sm text-foreground italic">
                "Hey team, hope you are well. Do you have any contacts or an email address I can reach out to to discuss any commercial opportunities or pop-ups? Appreciate it!"
              </p>
            </div>
            <p className="text-sm text-muted-foreground mt-2">
              This usually gives you an email with a signed-off name, which you can then use for a slightly warmer email outreach since you have already been in touch.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Guide;
